import localforage from 'localforage'

const USER_TOKEN = 'USER_TOKEN_WEB'
const USER_EMAIL = 'USER_EMAIL_WEB'

const setToken = token => localforage.setItem(USER_TOKEN, token)

const getToken = async () => {
  try {
    const token = await localforage.getItem(USER_TOKEN)

    if (token && typeof token === 'string' && token.includes('.')) {
      return token
    }

    if (token) {
      await localforage.removeItem(USER_TOKEN)
    }

    return undefined
  } catch (error) {
    console.error('Erro ao recuperar token:', error)
    return undefined
  }
}

const removeToken = (successCallback) => localforage.removeItem(USER_TOKEN, successCallback)

const removeCookie = async (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${process.env.REACT_APP_COOKIE_DOMAIN}`
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
}

const removeSSOCookie = async () => {
  await removeCookie(process.env.REACT_APP_COOKIE_NAME)
}

const setEmail = value => localforage.setItem(USER_EMAIL, value)

const getEmail = () => localforage.getItem(USER_EMAIL)

export { setToken, getToken, removeToken, removeSSOCookie, setEmail, getEmail }
